import { render, staticRenderFns } from "./BookingPositionPendingList.vue?vue&type=template&id=515e3fd7&"
import script from "./BookingPositionPendingList.vue?vue&type=script&lang=js&"
export * from "./BookingPositionPendingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports